import { render, staticRenderFns } from "./father.vue?vue&type=template&id=32172158"
import script from "./father.vue?vue&type=script&lang=js"
export * from "./father.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports